module.exports = __webpack_public_path__ + "static/CivTech_Global-e19e1ef03bfc8673ae1c7982dc1146c1.png";